import { useState } from 'react';
import api from '../../services/api';
import { API_ROUTES } from '../../services/apiRoutes';

export const useAddDataroom = (token) => {
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState(null);

  const addDataroom = async (dataroomData) => {
    if (!token) return;

    setAdding(true);
    setError(null);

    try {
      const response = await api.post(
        API_ROUTES.ADMIN_ADD_DATAROOM,
        dataroomData,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      setAdding(false);
      return response.data.dataroom;
    } catch (error) {
      setError(error.message || "Error adding dataroom");
      setAdding(false);
      throw error;
    }
  };

  return { addDataroom, adding, error };
};